<div class="modal-header pb-0 mb-1">
    <h2>{{ "SWAP_WORKLISTS" | translate }}</h2>
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body d-flex h-100 w-100 pb-0">
    <app-spinner [overlay]="true" [visible]="isUpdating"></app-spinner>
    <div class="d-flex flex-column justify-content-center w-100 h-100">
        @if (employeeTasksMap.length > 0) {
            <div class="d-inline-flex mx-auto swap-employees">
                <div class="d-flex flex-column employee-container">
                    <span class="m-auto employee-name">{{ selectedEmployees[0].employeeName }}</span>
                    <span class="my-auto">{{ selectedEmployees[0].skillLevelDescription }}</span>
                    @if (selectedEmployees[0].rosterDepartmentName) {
                        <span class="my-auto">{{ selectedEmployees[0].rosterDepartmentName }}</span>
                    }
                </div>
                <span class="my-auto vismaicon vismaicon-md icon-replace-blue mx-4"></span>
                <div class="d-flex flex-column employee-container">
                    <span class="m-auto employee-name">{{ selectedEmployees[1].employeeName }}</span>
                    <span class="my-auto">{{ selectedEmployees[1].skillLevelDescription }}</span>
                    @if (selectedEmployees[1].rosterDepartmentName) {
                        <span class="my-auto">{{ selectedEmployees[1].rosterDepartmentName }}</span>
                    }
                </div>
            </div>
            <div class="d-inline-flex my-3 employee-workshifts">
                <span class="w-100">
                    {{ selectedEmployees[0].employeeName }} {{ 'TASKS' | translate }}:
                    {{ selectedEmployees[0].shiftType }},
                    @if (selectedEmployees[0].fromDate !== selectedEmployees[0].toDate) {
                        {{ selectedEmployees[0].fromDate }}-{{ selectedEmployees[0].toDate }},
                    }
                    {{ selectedEmployees[0].fromTime }}-{{ selectedEmployees[0].toTime }}
                </span>
                <span class="w-100">
                    {{ selectedEmployees[1].employeeName }} {{ 'TASKS' | translate }}:
                    {{ selectedEmployees[1].shiftType }},
                    @if (selectedEmployees[1].fromDate !== selectedEmployees[1].toDate) {
                        {{ selectedEmployees[1].fromDate }}-{{ selectedEmployees[1].toDate }},
                    }
                    {{ selectedEmployees[1].fromTime }}-{{ selectedEmployees[1].toTime }}
                </span>
            </div>
            @if (swapShiftsTaskSelectionFeatureEnabled$ | async) {
                <div class="d-flex justify-content-center my-3">
                    <span>{{"SWAP_MODE_SELECTION_MODE" | translate}}</span>
                    <app-toggle
                        class="pl-1"
                        id="swapMode"
                        [(ngModel)]="allowTaskSelection"
                        (ngModelChange)="onSwapModeChanged($event)"
                    ></app-toggle>
                </div>
            }
            <div class="d-inline-flex routes-tables h-100">
                @for (employee of employeeTasksMap; track employee; let employeeIndex = $index) {
                    <app-table class="col-6">
                        <ng-container header>
                            @if ((swapShiftsTaskSelectionFeatureEnabled$ | async) && allowTaskSelection) {
                                <th class="checkbox-column">
                                </th>
                            }
                            <th class="index-column"></th>
                            <th class="flex-2 header" appTitleProvider>
                                <span>{{ 'NAME' | translate }}</span>
                            </th>
                            <th class="flex-3 header" appTitleProvider>
                                <span>{{ 'TASK' | translate }}</span>
                            </th>
                            <th class="flex-2 header" appTitleProvider>
                                <span>{{ 'ESTIMATED_VISIT' | translate }}</span>
                            </th>
                            <th class="flex-2 header" appTitleProvider>
                                <span>{{ 'TIME_WINDOW' | translate }}</span>
                            </th>
                            <th class="icon-column two"></th>
                        </ng-container>
                        <ng-container body>
                            @for (task of employeeTasksMap[employeeIndex]; track task.taskId; let i = $index) {
                                <tr [ngClass]="{'ride-sharing-table-row': task.rideSharingConfig}"
                                    [ngStyle]="{'border-color': task.color }"
                                    class="w-100">
                                    @if ((swapShiftsTaskSelectionFeatureEnabled$ | async) && allowTaskSelection) {
                                        <td class="checkbox-column">
                                            @if (task.isSynced) {
                                                <app-tooltip
                                                    appCustomPopover
                                                    popoverText="SWAP_SYNCED_TASK_TOOLTIP"
                                                    placement="left"
                                                    [adaptPlacement]="true"
                                                >
                                                    <ng-container icon>
                                                        <app-checkbox
                                                            [disable]="true"
                                                            [id]="'task-' + employeeIndex + '-' + task.taskId"
                                                        >
                                                        </app-checkbox>
                                                    </ng-container>
                                                </app-tooltip>
                                            } @else {
                                                <app-checkbox
                                                    [ngModel]="isTaskSelected(employeeIndex, task.routePlannerTaskId)"
                                                    (ngModelChange)="toggleTaskSelection(employeeIndex, task.routePlannerTaskId, $event)"
                                                    [id]="'task-' + employeeIndex + '-' + task.taskId"
                                                >
                                                </app-checkbox>
                                            }
                                        </td>
                                    }
                                    <td class="index-column" appTitleProvider>
                                        <span> {{ i + 1 }} </span>
                                    </td>
                                    <td class="flex-2" appTitleProvider>
                                        <span> {{ task.name }} </span>
                                    </td>
                                    <td class="flex-3" appTitleProvider>
                                        @if (task.rideSharingConfig) {
                                            <span>{{ task.serviceName | translate: {employeeName: getRideSharingCompanionsName(task)} }}</span>
                                        }
                                        @else if (!task.rideSharingConfig) {
                                            <span>{{ task.serviceName }}</span>
                                        }
                                    </td>
                                    <td class="flex-2" appTitleProvider>
                                        <span>{{ task | fromto }}</span>
                                    </td>
                                    <td class="flex-2 text-center" appTitleProvider>
                                        <span>{{ task.timeWindowStartTime }} - {{ task.timeWindowEndTime }}</span>
                                    </td>
                                    <td class="icon-column two">
                                        @if (task.isHeavy) {
                                            <app-tooltip
                                                appCustomPopover
                                                popoverText="TASK_HEAVY_INFO"
                                                placement="left"
                                                [adaptPlacement]="true"
                                            >
                                                <ng-container icon>
                                                    <span class="icon-heavy-weight"></span>
                                                </ng-container>
                                            </app-tooltip>
                                        }
                                        @if (task.isSynced) {
                                            <app-tooltip
                                                class="ml-1"
                                                appCustomPopover
                                                popoverText="TASK_SYNCED"
                                                placement="left"
                                                [adaptPlacement]="true"
                                            >
                                                <ng-container icon>
                                                    <span class="icon-merge"></span>
                                                </ng-container>
                                            </app-tooltip>
                                        }
                                        @if (task.doesRequirePhysicalAppearance === false) {
                                            <app-tooltip
                                                class="ml-1"
                                                appCustomPopover
                                                popoverText="TASK_REQUIRE_PHYSICAL_APPEARANCE_INFO"
                                                placement="left"
                                                [adaptPlacement]="true"
                                            >
                                                <ng-container icon>
                                                    <span class="icon-phone"></span>
                                                </ng-container>
                                            </app-tooltip>
                                        }
                                    </td>
                                </tr>
                            }
                        </ng-container>
                    </app-table>
                }
            </div>
        } @else {
            <span class="spinner spinner-lg w-100 h-100"></span>
        }
        <div class="d-inline-flex justify-content-end mt-3">
            <button class="btn btn-secondary mr-3"
                    (click)="dismissModal()"
            >
                <span class="my-auto">{{ 'CANCEL' | translate }}</span>
            </button>
            <button [disabled]="employeeTasksMap.length === 0"
                class="btn btn-primary d-inline-flex"
                (click)="performSwap()">
                <span class="my-auto mx-2"
                >{{ 'SAVE' | translate }}</span>
                <span class="vismaicon vismaicon-save vismaicon-md"></span>
            </button>
        </div>
    </div>
</div>


